module.exports = __webpack_public_path__ + "img/cup.d48cb558.svg";